import * as React from "react";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { CurrentUser, CurrentCompany } from "../../common/actions/Auth";

interface MappedProps {
  company: CurrentCompany;
  user: CurrentUser;
}

type Props = MappedProps;

const FeedbackLink: React.SFC<Props> = props => {
  const { company, user } = props;
  return (
    <span>
      表現したい内容が選択肢にない、という場合は
      <br />
      <a
        // tslint:disable-next-line:max-line-length
        href={`https://docs.google.com/forms/d/e/1FAIpQLSfQfJ_q9twdZe_jtmYkU_KaBzZSuOeRq82rYopwfd98UOvVJg/viewform?entry.750873098=${
          company.name
        }&entry.928353665=${user.name}`}
        target="_blank"
      >
        こちら
      </a>
      よりリクエストをお送りください。
    </span>
  );
};

function mapStateToProps(state: RootState): MappedProps {
  const { currentCompany, currentUser } = state.auth;
  return {
    company: currentCompany!,
    user: currentUser!,
  };
}

export default connect(mapStateToProps)(FeedbackLink);



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/FeedbackLink.tsx